// extracted by mini-css-extract-plugin
export default {"component":"k6hef"};